import { Link } from "react-router-dom";
import { t, catLabel } from "@/lib/i18n";

export default function SiblingNav({ siblings, isCocktail, lang }) {
  return (
    <nav data-testid="category-nav" className="mt-10">
      <p className="font-cinzel text-[10px] tracking-[0.3em] uppercase text-center mb-3 text-[var(--muted)]">
        {isCocktail ? t(lang, "otherCocktails") : t(lang, "otherCats")}
      </p>
      <div className="flex flex-wrap justify-center gap-2">
        {siblings.map((s) => (
          <Link
            key={s.slug}
            data-testid={`sibling-${s.slug}`}
            to={`/menu/${s.slug}`}
            className="text-xs font-medium rounded-full px-4 py-2 border transition-colors duration-300 border-[var(--line)] text-[var(--text-2)] hover:border-[#C5A059] hover:text-[var(--bordeaux)] bg-[var(--card)]"
          >
            {catLabel(s.slug, lang)}
          </Link>
        ))}
      </div>
    </nav>
  );
}
